/**
 * Created by Ning Jiang on 11/23/2016.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {BetWinMode} from "@nolimitcity/slot-game/bin/core/gametype/BetWinMode";
import {SpinMode} from "@nolimitcity/slot-game/bin/core/gametype/SpinMode";
import {IReelSets} from "@nolimitcity/slot-game/bin/core/reel/reelset/IReelSets";
import {ISymbolStateConfig, ISymbolStates} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {IWinRatios, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {IGameTweakerConfig} from "@nolimitcity/slot-game/bin/dev/tweaker/GameTweaker";
import {Back, Ease} from "gsap";
import {ITombOfNefertitiLayerConfig} from "./stage/ITombOfNefertitiLayerConfig";
import {TombOfNefertitiGameAssets} from "./TombOfNefertitiGameAssets";

export interface TombOfNefertitiISymbolStates extends ISymbolStates {
    readonly attention:ISymbolStateConfig;
}

export class TombOfNefertitiGameConfig implements IGameConfig {

    public static instance:TombOfNefertitiGameConfig = new TombOfNefertitiGameConfig();

    SPIN_DELAY:number = 0;
    BROWSER_FPS:number = 30;

    GAME_WIDTH:number = 1280;
    GAME_HEIGHT:number = 720;

    DEFAULT_LAYER_SCALE_OPTION:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {landscape : LayerScaleOption.FIT_WINDOW},
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_WINDOW
        }
    };

    LAYERS:ITombOfNefertitiLayerConfig = {
        BACKGROUND : {
            name : "background",
            scaleOption : LayerScaleOption.FIT_WINDOW,
            customOptions : {
                frame : {x : 0, y : 0, width : 720, height : 720}
            }
        },
        REEL_BACKGROUND : {name : "reelBackground"},
        LOGO : {name : "logo"},
        SYMBOLS : {name : "symbols"},
        SYMBOLS_ANIMATION : {name : "symbolsAnimation"},
        IDLE : {name : "symbolsIdle"},
        REEL_ATTENTION : {name : "reelAttention"},
        WILD_RAID : {name : "wildRaid"},
        ATTENTION_LAYER : {name : "ATTENTION_LAYER"},
        BET_LINES : {name : "betLines"},
        YELLOW_FIRE : {name : "yellowFire"},
        FOUNTAIN : {name : "coinFountain"},
        INITIAL_WIN_AMOUNT_BET_LINES : {name : "initialWInAmountBetLines"}, // #417
        WIN_PRESENTATIONS : {name : "winPresentations"},

        // FOREGROUND : {name: "foreground"},
        BIG_WIN : {name : "bigWin", scaleOption : LayerScaleOption.FIT_WINDOW},
        WIN_COUNT_UP : {name : "winCountUp"},
        FS_AWARD : {name : "fsAward"},
        CURSE_FEATURE : {name : "curseFeature"},
        MULTIPLIER : {name : "multiplier"},
        FREE_SPIN_INTRO : {name : "freespinIntroScreen", scaleOption : LayerScaleOption.FIT_WINDOW},
        FREE_SPIN_OUTRO : {name : "freespinOutroScreen", scaleOption : LayerScaleOption.FIT_WINDOW},
        INTRO : {name : "introScreen", scaleOption : LayerScaleOption.FIT_WINDOW},
        TWEAK_MODULE : {name : "tweakModule", scaleOption : LayerScaleOption.FIT_WINDOW}
    };

    BET_WIN_MODE:BetWinMode = BetWinMode.BET_LINE;
    SPIN_MODE:SpinMode = SpinMode.SPIN;

    X_OFFSET:number = 60; // this is taken into account to fit the reel area into portrait mode
    REEL_AREA_POS_X:number = 212 - this.X_OFFSET;
    REEL_AREA_POS_Y:number = 82;
    REEL_AREA_WIDTH:number = 858 + (2 * this.X_OFFSET);
    REEL_AREA_HEIGHT:number = 512;

    OVERLAPPING_SYMBOLS:string[] = ["M1", "M2", "W", "S"];
    SYMBOL_WIDTH:number = 166;
    SYMBOL_HEIGHT:number = 166;
    SYMBOL_BOTTOM_PADDING:number = -1; // kept it -1 because there was a line seen with two consecutive L syms on reel start up bounce
    SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION:number = 8;
    SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS:number = 196;
    REELS_NUM:number = 15;
    SPACE_BETWEEN_REELS:number = 7;
    REEL_DISPLAY_POSITIONS:[number, number][] = [
        [this.X_OFFSET + (this.SYMBOL_WIDTH * 0.5), 0], [this.X_OFFSET + (this.SYMBOL_WIDTH * 0.5), this.SYMBOL_HEIGHT + this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION], [this.X_OFFSET + (this.SYMBOL_WIDTH * 0.5), (2 * this.SYMBOL_HEIGHT) + (2 * (this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION))],
        [this.X_OFFSET + (this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS), 0], [this.X_OFFSET + (this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS), this.SYMBOL_HEIGHT + this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION], [this.X_OFFSET + (this.SYMBOL_WIDTH * 1.5 + this.SPACE_BETWEEN_REELS), (2 * this.SYMBOL_HEIGHT) + (2 * (this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION))],
        [this.X_OFFSET + (this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS * 2), 0], [this.X_OFFSET + (this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS * 2), this.SYMBOL_HEIGHT + this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION], [this.X_OFFSET + (this.SYMBOL_WIDTH * 2.5 + this.SPACE_BETWEEN_REELS * 2), (2 * this.SYMBOL_HEIGHT) + (2 * (this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION))],
        [this.X_OFFSET + (this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS * 3), 0], [this.X_OFFSET + (this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS * 3), this.SYMBOL_HEIGHT + this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION], [this.X_OFFSET + (this.SYMBOL_WIDTH * 3.5 + this.SPACE_BETWEEN_REELS * 3), (2 * this.SYMBOL_HEIGHT) + (2 * (this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION))],
        [this.X_OFFSET + (this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS * 4), 0], [this.X_OFFSET + (this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS * 4), this.SYMBOL_HEIGHT + this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION], [this.X_OFFSET + (this.SYMBOL_WIDTH * 4.5 + this.SPACE_BETWEEN_REELS * 4), (2 * this.SYMBOL_HEIGHT) + (2 * (this.SYMBOL_BOTTOM_PADDING + this.SYMBOL_BOTTOM_PADDING_FOR_REEL_POSITION))]
    ];
    SYMBOLS_NUM_IN_REEL:[number, number, number, number, number] = [1, 0, 1, 0, 1];
    MIN_STOPPING_TIME:number = 1.8; // #221 => check class jurisdiction-se.js and SlotApiEventManager.js
    REEL_SPIN_TIME:number = 1.1;
    REEL_FAST_SPIN_SPIN_TIME:number = 1.1;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_START_SYMBOL_CHANGE_TO_SPIN_STATE_DELAY:number = 0.3;
    REEL_SPIN_START_EASE:Ease = Back.easeIn.config(3);
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION:number = 0.2;
    REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY:number = 0;
    REEL_SPIN_STOP_ELASTIC_CONFIG:[number, number] = [1.5, 0.95];
    REEL_SPIN_QUICK_STOP_ELASTIC_CONFIG:[number, number] = [1.2, 0.75];
    REEL_SPIN_START_SPEED:number = 0.3;
    REEL_SPIN_SPIN_SPEED:number = 0.04;
    REEL_NEAR_WIN_SPIN_SPEED:number = 0.09;
    REEL_SPIN_STOP_SPEED:number = 0.3;
    REEL_SPIN_QUICK_STOP_SPEED:number = 0.3;
    REEL_STOP_DELAY:number = 0.1;
    REEL_QUICK_STOP_DELAY:number = 0.001;
    REEL_NEAR_WIN_STOP_DELAY:number = 0.8;
    REEL_SETS:IReelSets = {
        "BASE_REELSET" : [
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "M4", "L5", "M5", "L4", "S", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "S", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "S", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "S", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M2", "L3", "L1", "M5", "M1", "L1", "W", "L5",
                "M5", "L4", "M4", "M3", "L2", "L5", "M3", "M2", "M4", "L1",
                "M1", "L4", "L2", "M5", "M1", "L5", "L4", "L1", "M5", "L2",
                "M1", "L1", "L4", "W", "M1", "M3", "M4", "W", "M1", "L4",
                "M5", "L5", "M3", "L3", "L2", "M1", "M2", "L1", "L3", "L5",
                "L2", "L3", "L1", "L2", "M1", "M5", "L4", "L3", "L1", "L4",
                "L5", "M1", "L2", "L3", "L4", "L2", "L3", "M4", "L1", "L3",
                "L2", "L1", "L4", "M5", "M2", "S", "M5", "M3", "L4", "L2",
                "L5", "M2", "L2", "L5", "M5", "L3", "M1", "L2", "L5", "M1",
                "M5", "L5", "L2", "M1", "M5", "M2", "M4", "S", "L1", "M1",
                "L4", "L3", "M2", "M5", "M3", "M2", "W", "M3", "L1", "L3",
                "M5", "L4", "M3", "W", "L4", "L2", "L1", "L3", "M1", "M2"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M4", "L5", "M5", "L4", "S", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "S", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "S", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "S", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M2", "L3", "L1", "M5", "M1", "L1", "W", "L5",
                "M5", "L4", "M4", "M3", "L2", "L5", "M3", "M2", "M4", "L1",
                "M1", "L4", "L2", "M5", "M1", "L5", "L4", "L1", "M5", "L2",
                "M1", "L1", "L4", "W", "M1", "M3", "M4", "W", "M1", "L4",
                "M5", "L5", "M3", "L3", "L2", "M1", "M2", "L1", "L3", "L5",
                "L2", "L3", "L1", "L2", "M1", "M5", "L4", "L3", "L1", "L4",
                "L5", "M1", "L2", "L3", "L4", "L2", "L3", "M4", "L1", "L3",
                "L2", "L1", "L4", "M5", "M2", "S", "M5", "M3", "L4", "L2",
                "L5", "M2", "L2", "L5", "M5", "L3", "M1", "L2", "L5", "M1",
                "M5", "L5", "L2", "M1", "M5", "M2", "M4", "S", "L1", "M1",
                "L4", "L3", "M2", "M5", "M3", "M2", "W", "M3", "L1", "L3",
                "M5", "L4", "M3", "W", "L4", "L2", "L1", "L3", "M1", "M2"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M4", "L5", "M5", "L4", "S", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "S", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "S", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "S", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M2", "L3", "L1", "M5", "M1", "L1", "W", "L5",
                "M5", "L4", "M4", "M3", "L2", "L5", "M3", "M2", "M4", "L1",
                "M1", "L4", "L2", "M5", "M1", "L5", "L4", "L1", "M5", "L2",
                "M1", "L1", "L4", "W", "M1", "M3", "M4", "W", "M1", "L4",
                "M5", "L5", "M3", "L3", "L2", "M1", "M2", "L1", "L3", "L5",
                "L2", "L3", "L1", "L2", "M1", "M5", "L4", "L3", "L1", "L4",
                "L5", "M1", "L2", "L3", "L4", "L2", "L3", "M4", "L1", "L3",
                "L2", "L1", "L4", "M5", "M2", "S", "M5", "M3", "L4", "L2",
                "L5", "M2", "L2", "L5", "M5", "L3", "M1", "L2", "L5", "M1",
                "M5", "L5", "L2", "M1", "M5", "M2", "M4", "S", "L1", "M1",
                "L4", "L3", "M2", "M5", "M3", "M2", "W", "M3", "L1", "L3",
                "M5", "L4", "M3", "W", "L4", "L2", "L1", "L3", "M1", "M2"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "L4", "L3", "L2", "L5", "M4", "L2", "L4", "M5", "L1", "M3",
                "L5", "M4", "M1", "S", "L5", "L4", "M3", "W", "M5", "L2",
                "M4", "L3", "M2", "M5", "L4", "L1", "M3", "S", "L5", "L2",
                "L1", "M4", "L5", "M5", "L3", "L2", "L4", "M4", "M2", "L3",
                "M3", "L2", "W", "L5", "L4", "M3", "L1", "L3", "M5", "M3",
                "L4", "M4", "M5", "W", "L4", "M1", "M2", "M3", "L3", "L1",
                "M1", "M4", "L4", "M1", "W", "L3", "M1", "L1", "M4", "M2",
                "W", "M1", "M2", "L1", "M4", "L5", "W", "L4", "M3", "M4",
                "L3", "S", "L5", "L3", "M4", "L5", "L4", "W", "L5", "M1",
                "M5", "M4", "L5", "L2", "M4", "L4", "W", "L2", "L5", "M2",
                "M1", "L1", "L2", "M5", "M2", "L1", "L5", "M4", "M1", "M5",
                "L1", "L3", "W", "L2", "L5", "L1", "L3", "M3", "L4", "M4"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"]
        ],
        "RESPIN_MAIN_REELSET" : [
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "M4", "L5", "M5", "L4", "S", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "S", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "S", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "S", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M2", "L3", "L1", "M5", "M1", "L1", "W", "L5",
                "M5", "L4", "M4", "M3", "L2", "L5", "M3", "M2", "M4", "L1",
                "M1", "L4", "L2", "M5", "M1", "L5", "L4", "L1", "M5", "L2",
                "M1", "L1", "L4", "W", "M1", "M3", "M4", "W", "M1", "L4",
                "M5", "L5", "M3", "L3", "L2", "M1", "M2", "L1", "L3", "L5",
                "L2", "L3", "L1", "L2", "M1", "M5", "L4", "L3", "L1", "L4",
                "L5", "M1", "L2", "L3", "L4", "L2", "L3", "M4", "L1", "L3",
                "L2", "L1", "L4", "M5", "M2", "S", "M5", "M3", "L4", "L2",
                "L5", "M2", "L2", "L5", "M5", "L3", "M1", "L2", "L5", "M1",
                "M5", "L5", "L2", "M1", "M5", "M2", "M4", "S", "L1", "M1",
                "L4", "L3", "M2", "M5", "M3", "M2", "W", "M3", "L1", "L3",
                "M5", "L4", "M3", "W", "L4", "L2", "L1", "L3", "M1", "M2"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M4", "L5", "M5", "L4", "S", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "S", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "S", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "S", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M2", "L3", "L1", "M5", "M1", "L1", "W", "L5",
                "M5", "L4", "M4", "M3", "L2", "L5", "M3", "M2", "M4", "L1",
                "M1", "L4", "L2", "M5", "M1", "L5", "L4", "L1", "M5", "L2",
                "M1", "L1", "L4", "W", "M1", "M3", "M4", "W", "M1", "L4",
                "M5", "L5", "M3", "L3", "L2", "M1", "M2", "L1", "L3", "L5",
                "L2", "L3", "L1", "L2", "M1", "M5", "L4", "L3", "L1", "L4",
                "L5", "M1", "L2", "L3", "L4", "L2", "L3", "M4", "L1", "L3",
                "L2", "L1", "L4", "M5", "M2", "S", "M5", "M3", "L4", "L2",
                "L5", "M2", "L2", "L5", "M5", "L3", "M1", "L2", "L5", "M1",
                "M5", "L5", "L2", "M1", "M5", "M2", "M4", "S", "L1", "M1",
                "L4", "L3", "M2", "M5", "M3", "M2", "W", "M3", "L1", "L3",
                "M5", "L4", "M3", "W", "L4", "L2", "L1", "L3", "M1", "M2"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M4", "L5", "M5", "L4", "S", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "S", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "S", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "S", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M2", "L3", "L1", "M5", "M1", "L1", "W", "L5",
                "M5", "L4", "M4", "M3", "L2", "L5", "M3", "M2", "M4", "L1",
                "M1", "L4", "L2", "M5", "M1", "L5", "L4", "L1", "M5", "L2",
                "M1", "L1", "L4", "W", "M1", "M3", "M4", "W", "M1", "L4",
                "M5", "L5", "M3", "L3", "L2", "M1", "M2", "L1", "L3", "L5",
                "L2", "L3", "L1", "L2", "M1", "M5", "L4", "L3", "L1", "L4",
                "L5", "M1", "L2", "L3", "L4", "L2", "L3", "M4", "L1", "L3",
                "L2", "L1", "L4", "M5", "M2", "S", "M5", "M3", "L4", "L2",
                "L5", "M2", "L2", "L5", "M5", "L3", "M1", "L2", "L5", "M1",
                "M5", "L5", "L2", "M1", "M5", "M2", "M4", "S", "L1", "M1",
                "L4", "L3", "M2", "M5", "M3", "M2", "W", "M3", "L1", "L3",
                "M5", "L4", "M3", "W", "L4", "L2", "L1", "L3", "M1", "M2"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "L4", "L3", "L2", "L5", "M4", "L2", "L4", "M5", "L1", "M3",
                "L5", "M4", "M1", "S", "L5", "L4", "M3", "W", "M5", "L2",
                "M4", "L3", "M2", "M5", "L4", "L1", "M3", "S", "L5", "L2",
                "L1", "M4", "L5", "M5", "L3", "L2", "L4", "M4", "M2", "L3",
                "M3", "L2", "W", "L5", "L4", "M3", "L1", "L3", "M5", "M3",
                "L4", "M4", "M5", "W", "L4", "M1", "M2", "M3", "L3", "L1",
                "M1", "M4", "L4", "M1", "W", "L3", "M1", "L1", "M4", "M2",
                "W", "M1", "M2", "L1", "M4", "L5", "W", "L4", "M3", "M4",
                "L3", "S", "L5", "L3", "M4", "L5", "L4", "W", "L5", "M1",
                "M5", "M4", "L5", "L2", "M4", "L4", "W", "L2", "L5", "M2",
                "M1", "L1", "L2", "M5", "M2", "L1", "L5", "M4", "M1", "M5",
                "L1", "L3", "W", "L2", "L5", "L1", "L3", "M3", "L4", "M4"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"]
        ],
        "CURSE_REELSET" : [
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "L4", "M5", "L3", "M2", "M4", "L5", "M2", "M5", "M3", "L2",
                "M1", "M5", "L4", "S", "L5", "L3", "M3", "L1", "M2", "M4",
                "M5", "M3", "L3", "L5", "M1", "M5", "M2", "L5", "L2", "M1",
                "M4", "L4", "L1", "M2", "L4", "L3", "L5", "L4", "L1", "L2",
                "M2", "L5", "M1", "L2", "M5", "M1", "L2", "L3", "M3", "L4",
                "L1", "L3", "M2", "M5", "M3", "M2", "M1", "L1", "M4", "L3",
                "M5", "L1", "L4", "M4", "M1", "L3", "L2", "M3", "M2", "L1",
                "M4", "L5", "M3", "M1", "L2", "S", "L4", "M5", "L1", "M4",
                "M3", "L4", "L5", "L3", "S", "L5", "L3", "L4", "M5", "L5",
                "L3", "M5", "M1", "L4", "L2", "L3", "L4", "M4", "L5", "L3",
                "L2", "L4", "L3", "L5", "L4", "M5", "L2", "L1", "M4", "M3",
                "L4", "M4", "L2", "L4", "L3", "M1", "M2", "L2", "M3", "S"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "M4", "L5", "M5", "L4", "L3", "W", "L4", "L2", "M2", "L4",
                "M4", "M5", "L4", "L5", "L3", "L1", "W", "M5", "M2", "L4",
                "L3", "M5", "M4", "L1", "M1", "M4", "L3", "L1", "M5", "W",
                "L5", "L3", "L1", "L3", "L4", "W", "M2", "M5", "L3", "L5",
                "M2", "L3", "L3", "L5", "M3", "L3", "W", "M5", "M1", "L3",
                "M5", "L5", "M2", "M3", "M1", "M2", "W", "L5", "M3", "L4",
                "W", "L3", "M3", "L4", "L3", "M3", "M4", "L5", "L4", "M5",
                "W", "L1", "L2", "L4", "L3", "L2", "L5", "M5", "L3", "W",
                "L4", "L3", "L5", "L1", "W", "M3", "M2", "M4", "M5", "L5",
                "L4", "M5", "L1", "M4", "M2", "L3", "M1", "L5", "M2", "L4",
                "M5", "M1", "M4", "M3", "L2", "M5", "L3", "L1", "L4", "M1",
                "M3", "M2", "L4", "L1", "L3", "M4", "L2", "L1", "M5", "M4"],
            [
                "L4", "L3", "L2", "L5", "M4", "L2", "L4", "M5", "L1", "M3",
                "L5", "M4", "M1", "S", "L5", "L4", "M3", "W", "M5", "L2",
                "M4", "L3", "M2", "M5", "L4", "L1", "M3", "S", "L5", "L2",
                "L1", "M4", "L5", "M5", "L3", "L2", "L4", "M4", "M2", "L3",
                "M3", "L2", "W", "L5", "L4", "M3", "L1", "L3", "M5", "M3",
                "L4", "M4", "M5", "W", "L4", "M1", "M2", "M3", "L3", "L1",
                "M1", "M4", "L4", "M1", "W", "L3", "M1", "L1", "M4", "M2",
                "W", "M1", "M2", "L1", "M4", "L5", "W", "L4", "M3", "M4",
                "L3", "S", "L5", "L3", "M4", "L5", "L4", "W", "L5", "M1",
                "M5", "M4", "L5", "L2", "M4", "L4", "W", "L2", "L5", "M2",
                "M1", "L1", "L2", "M5", "M2", "L1", "L5", "M4", "M1", "M5",
                "L1", "L3", "W", "L2", "L5", "L1", "L3", "M3", "L4", "M4"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"],
            [
                "M3", "W", "L1", "M4", "L4", "L3", "M4", "W", "L2", "M3",
                "L3", "L5", "L2", "M4", "W", "L5", "L4", "L1", "L5", "M4",
                "M1", "L1", "L5", "S", "M4", "M2", "M1", "L3", "W", "L4",
                "M4", "M1", "L4", "L3", "L5", "L4", "M4", "L1", "L5", "M5",
                "L4", "M4", "W", "L2", "L1", "L3", "S", "L5", "M1", "L4",
                "M4", "L2", "W", "L4", "L1", "L2", "M5", "M4", "M3", "L5",
                "W", "M4", "L3", "M3", "L5", "M5", "M3", "L2", "M5", "M1",
                "W", "L4", "M4", "L2", "M1", "L5", "L3", "M4", "M1", "M5",
                "L2", "L1", "L4", "M5", "L1", "L3", "L5", "M3", "M5", "L4",
                "L2", "L3", "M4", "L4", "L2", "L3", "M5", "L2", "L4", "L3",
                "M3", "L2", "M2", "L4", "S", "L5", "M4", "M3", "L3", "L4",
                "L5", "M2", "L3", "L4", "M5", "L1", "L3", "M2", "S", "M3"]
        ],
        "FREESPIN_REELSET" : [
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"
            ],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"
            ]
        ],
        "REELS_FREESPIN" : [
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"
            ],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"
            ]
        ],
        "RESPIN_FS_REELSET" : [
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L3", "M5", "L1", "L3", "M5", "M2", "L4", "L1", "M1", "L4",
                "L3", "M3", "M5", "M1", "L4", "M3", "M5", "L3", "M2", "M3",
                "L1", "L2", "M1", "L3", "M5", "M3", "L5", "S", "L1", "L5",
                "M3", "M4", "L3", "L2", "M2", "M1", "L5", "M2", "M3", "L2",
                "M4", "M3", "M2", "L1", "M5", "L4", "L5", "L2", "M3", "M2",
                "L3", "L2", "M2", "M3", "L2", "M1", "L1", "L3", "M2", "M5",
                "L2", "M3", "M5", "M1", "L2", "L3", "L5", "L2", "M2", "M4",
                "M5", "L3", "M4", "M2", "M5", "L4", "L2", "L5", "M1", "M5",
                "L4", "L2", "M1", "M2", "L5", "L1", "L3", "M4", "M3", "L2",
                "L4", "L3", "L2", "M1", "L4", "L5", "L1", "M2", "L5", "L1",
                "M5", "L4", "M3", "M5", "M1", "L2", "L1", "L4", "L5", "M2",
                "S", "M3", "M5", "L4", "M2", "L1", "M1", "L4", "L5", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M5", "L4", "L3", "L2", "M3", "L1", "L2", "M5", "L5",
                "L2", "M1", "L4", "M4", "L5", "M5", "L2", "M3", "W", "L4",
                "M1", "L5", "L1", "L2", "M4", "L4", "M2", "L3", "S", "M1",
                "M5", "L4", "M1", "M5", "M3", "S", "M4", "L2", "L1", "M5",
                "L2", "L5", "M2", "M4", "L2", "M2", "M1", "L4", "L2", "L5",
                "M4", "L1", "M2", "L2", "M4", "M1", "L2", "L3", "L1", "M2",
                "M5", "L2", "L3", "L5", "L1", "L2", "L3", "L1", "M2", "L2",
                "L4", "M2", "L5", "L1", "M4", "M5", "L5", "M2", "L3", "L4",
                "L2", "M2", "M4", "M5", "W", "M4", "L1", "M5", "M4", "L5",
                "L3", "L2", "M5", "M4", "L1", "L3", "M4", "L2", "M2", "L1",
                "M1", "L2", "L1", "L3", "M2", "S", "L3", "L5", "L1", "L3",
                "M2", "L1", "M3", "L2", "M5", "M2", "S", "L2", "L4", "M5"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "L2", "M3", "L5", "L1", "M4", "L2", "M3", "L1", "L2", "M5",
                "M1", "L5", "M5", "W", "M4", "M5", "L5", "M1", "M5", "S",
                "M3", "L2", "L3", "S", "M2", "L2", "M3", "L3", "L4", "M5",
                "L1", "L5", "M3", "L4", "L1", "M3", "L2", "L1", "L4", "M4",
                "L1", "M5", "M1", "M4", "L2", "M3", "S", "L1", "M3", "S",
                "L5", "L2", "M3", "L3", "M4", "W", "L4", "L3", "L2", "L5",
                "M4", "L3", "L1", "M5", "M2", "L2", "L1", "L5", "M3", "L1",
                "L3", "M1", "L4", "L3", "L2", "M5", "L4", "M2", "M4", "L1",
                "M2", "L3", "M4", "M5", "W", "L1", "L4", "L3", "L1", "L4",
                "M3", "M4", "L3", "M1", "L5", "M5", "M1", "L3", "L4", "M2",
                "M1", "M3", "M2", "M5", "L3", "L2", "W", "M2", "L1", "M5",
                "M2", "M3", "L3", "L1", "M4", "M1", "M5", "L5", "L2", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "M2", "M3", "L5", "M4", "L3", "L1", "M3", "L5", "L4", "M3",
                "L5", "S", "M2", "L4", "M3", "M4", "L5", "L1", "L2", "L4",
                "M5", "M1", "L2", "M5", "M2", "L4", "L3", "S", "L2", "L5",
                "M2", "L4", "M5", "L5", "L2", "S", "L5", "M1", "M4", "L3",
                "L2", "L4", "L5", "M2", "M5", "L4", "M2", "M1", "L4", "L5",
                "M1", "M4", "L1", "L3", "L2", "M3", "L1", "L2", "M2", "L4",
                "M4", "L2", "M2", "L1", "M4", "M1", "M5", "L3", "L5", "M5",
                "L3", "M1", "L2", "L4", "M4", "L1", "W", "M5", "M2", "M4",
                "L5", "M5", "L4", "M4", "L2", "L4", "M1", "S", "L2", "L4",
                "L5", "M4", "L4", "L1", "M4", "L3", "L2", "L4", "M4", "L1",
                "L2", "M1", "L1", "M3", "M5", "M4", "M1", "L4", "L1", "M5",
                "L3", "L2", "L5", "M3", "L1", "M4", "M1", "M5", "L1", "L3"
            ],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"
            ],
            [
                "L4", "L1", "M4", "M2", "L2", "M4", "M1", "L3", "L2", "L4",
                "M2", "L5", "L3", "M4", "M2", "M5", "L3", "L2", "L1", "L4",
                "L5", "M3", "L2", "M2", "L3", "L2", "M1", "M2", "W", "L1",
                "L4", "M1", "L5", "L3", "M3", "M5", "L1", "M2", "M4", "L4",
                "M2", "M4", "L4", "L3", "M5", "L1", "M2", "L5", "L1", "L4",
                "M4", "L3", "L5", "L1", "L2", "L5", "M5", "L3", "M2", "L2",
                "L1", "M4", "M5", "L3", "L4", "M1", "M3", "L2", "L1", "M3",
                "L5", "L1", "M3", "M5", "L3", "L5", "M5", "M4", "M2", "L1",
                "L3", "M3", "M2", "L3", "M3", "M4", "L5", "M1", "M3", "L2",
                "L4", "L3", "M5", "M2", "L5", "W", "M3", "L2", "L3", "M2",
                "M1", "M4", "L5", "M5", "L2", "M2", "M5", "L2", "M2", "M3",
                "L5", "M4", "L3", "M2", "M5", "L2", "M4", "M3", "L4", "M4"
            ]
        ]
    };
    WIN_RATIOS:IWinRatios = {
        normalWin : [
            {
                ratio : 0,
                text : "Tiny Win",
                duration : 0,
                type : WinRatioType.TINY
            },
            {
                ratio : 1.5,
                text : "Small Win",
                duration : 0,
                type : WinRatioType.SMALL
            },
            {
                ratio : 3,
                text : "Medium Win",
                duration : 0.4,
                type : WinRatioType.MEDIUM
            },
            {
                ratio : 5,
                text : "Large Win",
                duration : 0.8,
                type : WinRatioType.LARGE
            }
        ],
        bigWin : [
            {
                ratio : 15,
                text : "Big Win",
                duration : 8.143,
                type : WinRatioType.BIG_WIN
            },
            {
                ratio : 25,
                text : "Mega Win",
                duration : 7.815,
                type : WinRatioType.MEGA_WIN

            },
            {
                ratio : 50,
                text : "Super Mega Win",
                duration : 8.628,
                type : WinRatioType.SUPER_MEGA_WIN
            }
        ]
    };
    GAME_TWEAKER_CONFIG:IGameTweakerConfig = {
        layer : this.LAYERS.TWEAK_MODULE.name,
        baseWindowWidth : 400,
        moduleHeight : 32,
        copyAllButtonText : "Copy All",
        buttonSkinIdle : "button",
        buttonSkinOver : "button",
        buttonSkinDown : "button",
        buttonSkinDisabled : "button-disabled"
    };
    PERFORMANCE_LOGGER:boolean = true;
    START_DELAY_FOR_RESPIN_WIN_SHOW:number = 0;

    private constructor() {
        if(TombOfNefertitiGameConfig.instance) {
            throw new Error("TombOfNefertitiGameConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS:(symName:string, stateKey:string) => [number, number] = (symName:string) => {
        if(this.OVERLAPPING_SYMBOLS.indexOf(symName) !== -1) {
            let overlapOffsetY = (this.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - this.SYMBOL_HEIGHT) / 2;

            return [0, -overlapOffsetY];
        } else {
            return [0, 0];
        }
    };

    SYMBOL_STATES:TombOfNefertitiISymbolStates = {
        normal : {
            prio : 0,
            keyword : "normal",
            texturesCreator : (symName:string) => {
                return TombOfNefertitiGameAssets.getSymbolStateTextures(symName);
            },
            offsetGetter : this.OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS
        },
        spin : {
            prio : 1,
            keyword : "spin",
            texturesCreator : (symName:string, stateKey:string) => {
                return TombOfNefertitiGameAssets.getSymbolStateTextures(symName, stateKey);
            },
            offsetGetter : this.OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS
        },
        attention : {
            prio : 2,
            keyword : "attention",
            texturesCreator : () => {
                return TombOfNefertitiGameAssets.getSymbolAttentionStateTexture();
            },
            offsetGetter : this.OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS
        },
        noWin : {
            prio : 3,
            keyword : "noWin",
            texturesCreator : (symName:string) => {
                return TombOfNefertitiGameAssets.getSymbolStateTextures(symName);
            },
            offsetGetter : this.OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS
        },
        win : {
            prio : 4,
            keyword : "win",
            texturesCreator : (symName:string) => {
                if(symName.indexOf("L") !== -1) {
                    return TombOfNefertitiGameAssets.getSymbolStateTextures(symName);
                }
                return TombOfNefertitiGameAssets.getSymbolWinStateTexture(symName);
            },
            offsetGetter : this.OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS
        },
        hidden : {
            prio : 5,
            keyword : "hidden"
        },
        idle : {
            prio : 6,
            keyword : "idle",
            texturesCreator : (symName:string) => {
                if(symName.indexOf("L") !== -1) {
                    return TombOfNefertitiGameAssets.getSymbolStateTextures(symName);
                }
                return TombOfNefertitiGameAssets.getSymbolWinStateTexture(symName);
            },
            offsetGetter : this.OFFSET_GETTER_FOR_OVERLAPPING_SYMBOLS
        }
    };

    CURSE_REEL_SET_LAST_THREE_SYMS:string[];
    CURRENT_SPIN_HAS_CURSE:boolean = false;

    USABLE_FONT:string = "NFL Saints";

    // #403
    WIN_BELOW_STAKE: boolean = false;

    FS_OUTRO_VISIBLE: boolean = false;
}